import React from 'react';
import { Slider } from 'antd';

export default function KoSlider(props) {
  const formatter = (value) => `${value}%`;

  return (
    <Slider
      {...props}
      tooltip={{
        formatter,
        open: props.value > 0 ? true : false
      }}
    />
  );
}
